<template>
  <div class="flex flex-column justify-between col-12">
    <div v-if="itemsInWorkspace.length" class="flex flex-column col-12">
      <div class="flex flex-column white-bg justify-between relative col-12 full-height">
        <div v-if="itemsInWorkspace.length" class="flex col-12 items-center flex-wrap justify-center">
          <template v-for="(item, i) in itemsInWorkspace">
            <NewTDASubscriptionItem v-if="isSubscriptionTDA" :key="`sub-${i}`" />
            <NewTDACartItem
              v-else
              :key="`cart-${i}`"
              :item="item"
              :value="value"
              :total="total"
              :scroll-to-top="scrollToTop"
            />
          </template>
        </div>
      </div>
      <div v-if="isStage && hasInstallments" class="flex flex-wrap col-12 no-box my2 white-bg px3 py2">
        <div class="flex col-12"><input v-model="parceled" type="radio" :value="false"><label class="flex items-center mr1 pointer">Paiement en un fois</label></div>
        <div class="flex col-12"><input v-model="parceled" type="radio" :value="true"><label class="flex items-center mr1 pointer">Paiement en 4 fois sans frais</label></div>
      </div>
      <div v-else-if="hasInstallments" class="flex col-12 no-box mt2 white-bg my2 px3 py2">
        <input id="parceled" v-model="parceled" type="checkbox" value="true"><label for="parceled" class="flex items-center mr1 pointer">Paiement en 4 fois</label>
      </div>

      <div v-if="order" class="flex col-12 my2">
        <Parcel :parceled="parceled" />
      </div>
      <CartRecapPromo v-if="isSGWorkspace && !hasPromo && !applyPromo && !hasPartnerTariff" />

      <!-- Pégase Pensions -->
      <div v-if="isPension && isRecurring && isImpersonateMode " class="flex flex-column col-12 mt2 white-bg p2 justify-between">
        <PensionOptions @subscriptionStart="setSubscriptionStartDate" @setOptionHorse="setHorseOption" />
      </div>

      <!-- cgi-->
      <div v-if="!isImpersonateMode" class="col-12 flex no-box px1 py2 items-center flex-column white-bg mt2">
        <div v-if="!isSubscriptionTDA" class="flex col-12 px0 items-center" @click="cgi = !cgi">
          <div class="mr1">
            <input id="cgi" v-model="cgi" type="checkbox" class="pointer">
          </div>
          <label class="h5 self-center">
            Je certifie avoir lu et accepté <a class="h4 pointer cgi" :href="cgiHref" target="_blank"><span class="h4 pointer cgi underline">les conditions générales de vente</span></a> et <a class="h4 pointer cgi" :href="regHref" target="_blank"><span class="h4 pointer cgi underline">le règlement intérieur.</span></a>
          </label>
        </div>
        <div v-else class="flex col-12 px0 items-center" @click="cgi = !cgi">
          <div class="mr1">
            <input id="cgi" v-model="cgi" type="checkbox" class="pointer">
          </div>
          <div class="col-11">
            <span class="h5">Je certifie avoir lu et accepté </span>
            <label class="self-center">
              <a class="h4 pointer" :href="cgiHref" target="_blank"><span class="h4 pointer underline strong-blue">les conditions générales de vente</span></a>
              <span class="h4"> et </span>
              <a class="h4 pointer" :href="regHref" target="_blank"><span class="h4 pointer underline strong-blue">le règlement intérieur.</span></a>
            </label>
          </div>
        </div>
        <span v-if="canShowCgiError" class="h5 block col-12 alert no-box red lighter-grey-bg p1 cgiError">
          <i class="mt2 icon h5 mr2 ml1 red icon-stop"></i>Merci de bien vouloir lire et accepter les conditions générales de ventes et le règlement intérieur
        </span>
      </div>
      <ImpersonatePromo
        v-else-if="isImpersonateMode && isSGWorkspace"
        class="py2 px1 items-center impersonatePromoMargin"
        :fee="(totalPriceCart - recurringPrice).toFixed(2)"
        :recurring-price="recurringPrice"
        @discountAmount="changeAmount"
        @discountAmountFee="changeAmountFee"
        @discountMetric="selectMetric"
        @discountMotive="selectMotive"
        @applyPromo="setApplyPromo"
      />

      <Installment :show-no-selected-error="canShowCartInstallmentsError" @selected-installments="setInstallmentOption" />
    </div>
  </div>
</template>

<script>
import Parcel from '@/components/cart/Parcel.vue';
import CartRecapPromo from '@/components/cart/CartRecapPromo.vue';
import NewTDACartItem from '@/components/cart/NewTDACartItem.vue';
import NewTDASubscriptionItem from '@/components/cart/NewTDASubscriptionItem.vue';
import ImpersonatePromo from '@/components/promos/ImpersonatePromo.vue';
import Installment from '@/components/cart/Installment.vue';
import PensionOptions from '@/components/pegase/PensionOptions.vue';

import { computeTotalPrice } from '@/utils/labels';
import { backToAlpha, horseOptions } from '@/utils/utils';
import { hasInstallments, subscriptionPaymentInfo } from '@/utils/logics';

export default {
  name: 'NewTDACartRecap',
  components: {
    NewTDACartItem,
    Parcel,
    CartRecapPromo,
    NewTDASubscriptionItem,
    ImpersonatePromo,
    PensionOptions,
    Installment
  },
  props: {
    scrollToTop: Function,
    total: [Number, String],
    canShowCgiError: Boolean,
    canShowCartInstallmentsError: Boolean
  },
  data () {
    return {
      cart: this.$store.state.cart,
      offerInfo: this.$store.state.offerInfo,
      product: this.$store.state.product,
      siteInfo: this.$store.state.siteInfo,
      parceled: false,
      loading: false,
      cgi: false,
      workspace: this.$store.getters.workspace,
      showCustomPayments: false,
      promoAmountFee: null,
      promoAmount: null,
      promoMotive: null,
      selectedMetric: null,
      applyPromo: false,
      subscriptionStartDate: null,
      horseOptions
    };
  },
  computed: {
    isSubscriptionTDA () {
      return this.$store.state.subscriptionTDA;
    },
    isSGWorkspace () {
      return this.$store.state.siteInfo.payments_platform === 'sharegroop';
    },
    order () {
      return this.$store.state && this.$store.state.order;
    },
    paymentMethods () {
      return this.siteInfo?.tda_settings?.impersonate?.payment_methods || [];
    },
    isImpersonateMode () {
      return this.$store.getters.isImpersonateMode;
    },
    btnLabel () {
      return this.$isImpersonateMode ? 'Envoyer le lien de Paiement' : 'Valider et regler';
    },
    hasInstallments () {
      return hasInstallments(this.itemsInWorkspace[0].details[0], this.totalPrice);
    },
    workspaceCart () {
      return (this.cart.items || []).find(item => item.workspace === this.workspace);
    },
    showValider () {
      const cart = (this.cart.items || []).find(item => item.workspace === this.workspace);

      return cart && Object.keys(cart).length !== 0;
    },
    productUrl () {
      return `${this.$store.getters.alphaURL}${this.$store.state.product.url}`;
    },
    cgiHref () {
      return `${this.$store.getters.siteURL}/cgi`;
    },
    regHref () {
      return `${this.$store.getters.siteURL}/reglement-interieur`;
    },
    isRecurring () {
      if (this.offerInfo) {
        return this.offerInfo.detail.recurring;
      }
      if (this.workspaceCart) {
        return this.workspaceCart.details[0].recurring;
      }
      return false;
    },
    isStage () {
      if (this.offerInfo) {
        return this.offerInfo.detail.inscription && ['STAGE'].includes(this.offerInfo.offer_type);
      }
      if (this.workspaceCart) {
        return this.workspaceCart.details[0].inscription && ['STAGE'].includes(this.workspaceCart.details[0].offer_type);
      }
      return false;
    },
    isPension () {
      if (this.offerInfo) {
        return this.offerInfo.isPension;
      }
      if (this.workspaceCart) {
        return this.workspaceCart.details[0].isPension;
      }
      return false;
    },
    itemsInWorkspace () {
      if (this.cart && this.cart.items) {
        return this.cart.items.filter(i => i.workspace === this.workspace);
      }
      return [];
    },
    hasPromo () {
      return this.itemsInWorkspace.some(item => item.details.some(participant => participant.promo));
    },
    hasPartnerTariff () {
      // Check if any cart item has a Gymlib code (partner tariff)
      return this.itemsInWorkspace.some(item => item.details.some(detail => detail.gymlibCode));
    },
    priceInfo () {
      return this.cart.items.find(item => item.workspace === this.workspace).priceInfo;
    },
    totalPriceCart () {
      return this.priceInfo ? this.priceInfo.totalPrice : null;
    },
    promoCampaign () {
      return this.$store.state.promoCampaign;
    },
    feeHasError () {
      if (this.promoAmountFee && this.selectedMetric) {
        const discount = parseFloat(this.promoAmountFee);
        switch (this.selectedMetric) {
          case 'euro': {
            const price = parseFloat(this.fee);
            return discount < 0 || discount > price;
          }
          case 'percentage': {
            return discount < 0 || discount > 100;
          }
          default:
            return false;
        }
      }
      return false;
    },
    priceHasError () {
      if (this.promoAmount && this.selectedMetric) {
        const discount = parseFloat(this.promoAmount);
        switch (this.selectedMetric) {
          case 'euro': {
            const price = parseFloat(this.recurringPrice);
            return discount < 0 || discount > price;
          }
          case 'percentage': {
            return discount < 0 || discount > 100;
          }
          default:
            return false;
        }
      }
      return false;
    },
    value () {
      const price = parseFloat(this.totalPriceCart);
      const metric = this.selectedMetric || (this.promoCampaign ? 'percentage' : null);
      const amount = parseFloat(this.promoAmount || (this.promoCampaign ? this.promoCampaign.discount : null));
      const amountFee = parseFloat(this.promoAmountFee || (this.promoCampaign ? this.promoCampaign.discount : null));

      if ((amount || amountFee) && metric) {
        if (this.priceHasError || this.feeHasError) {
          return price;
        }

        switch (metric) {
          case 'euro': {
            let discountPrice = price;
            if (amountFee) discountPrice = parseFloat((discountPrice - amountFee).toFixed(2));
            if (amount) discountPrice = parseFloat((discountPrice - amount).toFixed(2));
            return discountPrice;
          }
          case 'percentage': {
            return parseFloat(((1 - (amount / 100)) * price).toFixed(2));
          }
          default:
            return price;
        }
      }
      return price;
    },
    totalPrice () {
      return this.computeTotalPrice(this.itemsInWorkspace);
    },
    recurringPrice () {
      return subscriptionPaymentInfo().recurringPayment;
    }
  },
  watch: {
    cgi: function (newVal, _oldVal) {
      this.$emit('updateCgi', newVal);
    },
    parceled: function (newVal, _oldVal) {
      this.$emit('updateParceled', newVal);
    }
  },
  mounted () {
    this.scrollToTop();
  },
  methods: {
    computeTotalPrice,
    backToAlpha,
    selectMetric (value) {
      this.$emit('discountMetric', value);
      this.selectedMetric = value;
    },
    changeAmount (value) {
      this.$emit('discountAmount', value);
      this.promoAmount = value;
    },
    changeAmountFee (value) {
      this.$emit('discountAmountFee', value);
      this.promoAmountFee = value;
    },
    setApplyPromo (value) {
      this.applyPromo = value;
    },
    selectMotive (value) {
      this.$emit('discountMotive', value);
      this.promoMotive = value;
    },
    setSubscriptionStartDate (value) {
      this.$emit('subscriptionStart', value);
    },
    setHorseOption (value) {
      this.$emit('setOptionHorse', value);
    },
    setInstallmentOption (value) {
      this.$emit('selected-installments', value);
    }
  }
};
</script>

<style lang="scss" scoped>
  .cgi{
    font-size: 16px;
    color: inherit;
  }

  .cgiError{
    font-size: 14px;
  }

  input[type="checkbox"] {
    position: relative;
    z-index: 0 !important;
    margin-left: 0.7rem;
  }

  .cgiPadding{
    padding: 1rem;
  }

  .impersonatePromoMargin {
    margin-left: 0.7rem;
  }
</style>
